import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./custom.css";
import "./i18n";
import AdnMenu from "./components/common/adnMenu/AdnMenu";
import { useSelector } from "react-redux";
import AdnEmptyLayoutContent from "./components/common/adnMenu/AdnEmptyLayoutContent";
import ProtectedRoute from "./components/common/route/ProtectedRoute";
import { PageTitleProvider } from "./contexts/PageTitleContext";
import {
  AppRoutes,
  AuthenticatedRoutes,
  UnauthenticatedRoutes,
} from "./AppRoutes";
import { TenantProvider } from "./contexts/TenantContext";

import { APP_VERSION } from './version';

function App() {

  const { t } = useTranslation();
  const { userIsAuthenticated } = useSelector(
    (state) => state.userIsAuthenticated
    );

    useEffect(() => {
        const checkForUpdates = async () => {
            try {
                const response = await fetch('/version.json?' + Date.now());
                const { version } = await response.json();

                if (version !== APP_VERSION) {
                    // Show update notification or force reload
                    let message = t("app.newVersionAvailable");
                    window.alert(message);
                    
                }
            } catch (error) {
                console.log('Version check failed:', error);
            }
        };

        checkForUpdates();
    }, []);
  return (
    <PageTitleProvider>
      <TenantProvider>
        {!userIsAuthenticated && (
          <AdnEmptyLayoutContent>
            <Routes>
              {UnauthenticatedRoutes.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                );
              })}
            </Routes>
          </AdnEmptyLayoutContent>
        )}
        {userIsAuthenticated && (
          <AdnMenu>
            <Routes>
              {AuthenticatedRoutes.map((route, index) => {
                return route.roles ? (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <ProtectedRoute
                        redirectTo={AppRoutes.forbidden.path}
                        roles={route.roles}
                      >
                        {route.element}
                      </ProtectedRoute>
                    }
                  />
                ) : (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                );
              })}
            </Routes>
          </AdnMenu>
        )}
      </TenantProvider>
    </PageTitleProvider>
  );
}

export default App;
